import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'
import { getId } from '@/utils/auth'

export function gainlist(data) {
    return request({
        url: "/spreader/sgain/list",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function settleAccounts(data) {
    return request({
        url: "/spreader/sgain/settleAccounts",
        headers: {
            isToken: true,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function getdays() {
    return request({
        url: "/spreader/sgain/getdays",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: null
    });
}


// WEBPACK FOOTER //
// ./src/api/spreader/gain.js